<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="EP">Disdaining kings, we give ourselves our laws to the sound of cannons and of bugle calls. And now, on the sinister behalf of black kings, each Judas is a friend of every Cain.</p>
<p class="EPC"><span class="ePub-I">—Rubén Darío, “To Columbus”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?5bd6dd96